// Mock data for GSD Company website

export const navigationLinks = [
  { name: 'HOME', href: '#home' },
  { name: 'SERVICES', href: '#services' },
  { name: 'ABOUT', href: '#about' },
  { name: 'SUCCESS TEAM', href: '#team' },
  { name: 'MORE', href: '#more', hasDropdown: true }
];

export const heroSlides = [
  'LEADERS IN CLEAN COAL AND RAW MATERIALS',
  'Global Supply Chain Management Experts',
  'Tenement Management Services',
  'Northern Territory | Singapore | Global Sales & Distribution'
];

export const services = [
  {
    id: 1,
    title: 'Technical Advisory & Geological Services',
    description: 'Global Sales & Distribution has a dedicated geological and engineering team that can review historical datasets, develop bespoke processing flow charts, conduct field studies, and collect samples – maintaining chain of custody to identify commodity spec to ensure the highest possible offtake price available. GSD is able to conceptualise and budget mine to mill, and mill to transport interactions, GSD can provide a full logistical road map and demonstrate how product can go from the mine face through to the end customer.',
    image: '/images/technical-advisory.jpg'
  },
  {
    id: 2,
    title: 'Sourcing',
    description: 'Global Sales & Distribution offers supply chain management solutions for businesses around the world. We specialize in sourcing raw materials for export, as well as providing efficient logistics and shipping solutions. Our dedicated team is committed to providing you with the best services, and we strive to ensure that each transaction is smooth and stress-free. We understand how important it is to get the right products to the right places at the right time.',
    image: '/images/sourcing.jpg'
  },
  {
    id: 3,
    title: 'Products',
    description: 'Global Sales & Distribution is your go-to source for supply chain management and global sales. We offer a comprehensive range of services to best meet the needs of our clients. We specialize in the trading of all bulk commodity products including Coal, Copper, Aluminum, Gold and other base metals. Our goal is to provide our clients with the most efficient and cost effective solutions for their supply chain needs.',
    image: '/images/products.jpg'
  },
  {
    id: 4,
    title: 'Renewable Energy',
    description: 'Global Sales & Distribution is a full-service supply chain management company. We specialize in delivering global leading products in Solar and Hydrogen Energy Solutions. Our expertise allows us to provide cost-effective solutions and customized supply chain services. Our world-class lithium battery and offgrid energy solutions are designed to make energy delivery more efficient and cost-effective.',
    image: '/images/solar.jpg'
  }
];

export const stats = [
  { value: '2015', label: 'Year Established' },
  { value: '6', label: 'Projects Completed' },
  { value: '14', label: 'Trading Partners' }
];

export const aboutContent = {
  title: 'ABOUT',
  description: 'Global Sales & Distribution is a Western boutique multi-commodity physical brokerage and trading house focused on the supply chain management of energy and industrial raw materials, technology metals, special ores and industrial minerals, and base metals. We have a deep understanding of the commodities markets and extensive experience and network of relationships across the Asian region and beyond. Our freight and logistics operations support our global supply chain management and help to ensure that our customers receive the highest quality products in the most efficient and cost-effective manner.'
};

// `clients` was removed 27 Sep 2026: ten placeholder logos on via.placeholder.com,
// a service that is now offline and returns nothing. The array was never imported —
// ClientsSection.jsx carries its own `partners` list of real, self-hosted logos.

export const contactInfo = {
  phone: '+61 400721443',
  offices: [
    {
      title: 'Head Office - Australia',
      address: ['Tenancy 1, Suite J', '34 McLachlan Street', 'Darwin NT 0800'],
      phone: '+61400721443'
    },
    {
      title: 'Singapore Office',
      address: ['4 Shenton Way,', '4/03 SGX Centre 2'],
      phone: '+61400721443'
    }
  ],
  employment: 'To apply for a job with GSD, please submit your cover letter and C.V. using the contact form.'
};
